import { useMemo } from 'react';
import { doc, DocumentReference, getFirestore } from 'firebase/firestore';
import { UserProfile } from '@finvari/deliver';
import { useSubscribedDoc } from '../utils/firebaseHooks';

export function useUserProfile(uid: string | null | undefined) {
  const docRef = useMemo(() => {
    if (!uid) return undefined;
    const db = getFirestore();
    return doc(db, 'userProfile', uid) as DocumentReference<UserProfile>;
  }, [uid]);

  return useSubscribedDoc<UserProfile, 'userProfile'>(docRef, 'userProfile');
}
